import { useMemo, useRef } from 'react'

import { Container, Footer } from 'core/components'
import { LogoContainer, Svg } from 'core/components/Footer/styles'


import LayoutContext from './context'
import { Content, Header, Main, Wrapper } from './styles'

function AuthLayout({ children }: any) {
  const layoutRef = useRef<HTMLDivElement>(null)

  const props = useMemo(() => ({ ref: layoutRef.current }), [])

  return (
    <LayoutContext.Provider value={props}>
      <Wrapper ref={layoutRef}>
        <Main>
          <Header>
            <LogoContainer>
              <a
                href="https://www.instagram.com/orul_tech/"
                aria-label="Orul Tecnologia"
              >
                <Svg viewBox="0 0 117.03 120.89">
                  <path
                    className="cls-1"
                    fill="#009fe3"
                    d="M47.26,97h2L38.44,114.67a37.54,37.54,0,0,1-4-.69c-1.12-.3-2.29-.65-3.41-1-.55-.2-1.06-.45-1.61-.65a37.64,37.64,0,0,1-4.75-2.52,32.28,32.28,0,0,1-4.3-3.27c-.45-.45-.89-.84-1.34-1.24-1.12-1.09-2.12-2.23-3.13-3.41a41.35,41.35,0,0,1-4-5.9,47.34,47.34,0,0,1-3-6.68A48,48,0,0,1,6.11,73.12V47.62a47,47,0,0,1,5.81-22.78,46,46,0,0,1,4-5.9A40.68,40.68,0,0,1,19,15.53a14.87,14.87,0,0,1,1.34-1.24A37.16,37.16,0,0,1,24.65,11,37.64,37.64,0,0,1,29.4,8.5c.55-.25,1.06-.45,1.61-.65,1.12-.39,2.29-.74,3.41-1s2.23-.44,3.35-.59L49.22,23.75h-2c-11.16,0-20.32,10.79-20.32,23.87v25.5C26.94,86.25,36.1,97,47.26,97Z"
                  />
                  <path
                    className="cls-1"
                    fill="#009fe3"
                    d="M69.77,97h-2l10.77,17.63a37.54,37.54,0,0,0,4-.69c1.12-.3,2.29-.65,3.41-1,.56-.2,1.06-.45,1.62-.65a37.51,37.51,0,0,0,4.74-2.52,32.28,32.28,0,0,0,4.3-3.27c.45-.45.9-.84,1.34-1.24,1.12-1.09,2.13-2.23,3.13-3.41a41.42,41.42,0,0,0,4-5.9,47.18,47.18,0,0,0,5.8-22.83V47.62a47.18,47.18,0,0,0-5.8-22.78,47.15,47.15,0,0,0-4-5.9A39,39,0,0,0,98,15.53a13.63,13.63,0,0,0-1.34-1.24A37.16,37.16,0,0,0,92.38,11,37.51,37.51,0,0,0,87.64,8.5c-.56-.25-1.06-.45-1.62-.65-1.12-.39-2.29-.74-3.41-1s-2.23-.44-3.35-.59L67.82,23.75h2c11.17,0,20.33,10.79,20.33,23.87v25.5C90.1,86.25,80.94,97,69.77,97Z"
                  />
                  <path
                    className="cls-2"
                    d="M70.77,4.58H46.31c-2.41,0-3.93,2.29-2.71,4.13l4.61,7.09,1.49,2.29,6.13,9.42a3.3,3.3,0,0,0,5.37,0l6.14-9.42,1.48-2.29,4.61-7.09C74.66,6.87,73.13,4.58,70.77,4.58Z"
                  />
                  <path
                    className="cls-2"
                    fill="#0e1727;"
                    d="M70.77,116.31H46.31c-2.41,0-3.93-2.29-2.71-4.13l4.61-7.09,1.49-2.29,6.13-9.42a3.3,3.3,0,0,1,5.37,0l6.14,9.42,1.48,2.29,4.61,7.09C74.66,114,73.13,116.31,70.77,116.31Z"
                  />
                </Svg>
              </a>
            </LogoContainer>
          </Header>
          <Container>
            <Content>{children}</Content>
          </Container>
        </Main>
        <Container>
          <Footer />
        </Container>
      </Wrapper>
    </LayoutContext.Provider>
  )
}

export { AuthLayout }
